import { DataTable } from "@/shared/ui/data-table.tsx"
import { ColumnHistory as columns } from "./HistoryTable"
import { useGetPlaygroundHistory } from "../../api/play-api"
import { useState } from "react"
import HistoryResults from "./HistoryResults"
import { Undo2 } from "lucide-react"
import { Link } from "react-router-dom"

const History = () => {
  const { playHistoryData } = useGetPlaygroundHistory()
  const [eventId, setEventId] = useState(0)
  return (
    <div className="w-full mt-[5vh] h-[95vh] relative">
      <Link to=".." className="bg-black p-2 text-sm text-white rounded-lg absolute top-5 right-5 flex items-center gap-2">
        <Undo2 size={14} />
        <span className="hidden sm:block">
          Go to Playground
        </span>
        </Link>
      <div className="w-full flex flex-col gap-4 items-center justify-center py-6">
        <h1 className="text-2xl font-montserrat">Event history</h1>
        {playHistoryData && <div className="w-full max-sm:px-4 sm:w-2/3">
          <DataTable columns={columns(setEventId)} data={playHistoryData.data} />
        </div>}
        {eventId !== 0 && playHistoryData && <HistoryResults eventId={eventId} playHistoryData={playHistoryData} />}
      </div>
    </div>
  )
}

export default History
